import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
  EditButton,
  BooleanField,
  TopToolbar,
  FilterButton,
  CreateButton,
  ExportButton,
} from "react-admin";
import { DatagridSX, ListSX } from "../../../styled/custom";
import CustomFilterMedia from "../../../filter/custom-filter-media";
import MediaExporter from "../../../exporter/media-exporter";
import ControlAudio from "../../../ui/control-audio";
import LinkField from "../../../ui/link-field";
import MediaClassField from "../../../ui/media-class-field";
import { MediaThumbnailField } from "../../../ui/media-thumbnail";
import ProcessingStatusField from "../../../ui/processing-status-field";
import { useLocation } from "react-router-dom";

export const useQueryParam = (name) => {
  return new URLSearchParams(useLocation().search).get(name);
};

const MediaList = () => {
  const media_class = useQueryParam("media_class");
  return (
    <List
      title={media_class ? `Cesta de Produtos (${media_class})` : "Cesta de Produtos"}
      sort={{ field: "id", order: "desc" }}
      filters={CustomFilterMedia}
      exporter={MediaExporter}
      actions={
        <TopToolbar>
          <FilterButton />
          <CreateButton state={{ record: { media_class } }} />
          <ExportButton />
        </TopToolbar>
      }
      sx={ListSX}
    >
      <Datagrid rowClick="show" bulkActionButtons={false} sx={DatagridSX}>
        <TextField source="id" sortable={false} />
        <TextField source="number_downloads" label="Downloads" sortable={false} />
        <MediaClassField source="media_class" label="Classe" sortable={false} />
        <TextField source="category_media.name" label="Categoria" sortable={false} />
        <FunctionField label="Thumbnail" render={() => <MediaThumbnailField scale={0.35} />} sortable={false} />
        <TextField source="name" label="Nome" sortable={false} />
        {/* <TextField source="description" label="Descrição" sortable={false} /> */}
        {/* <FunctionField
          label="Status"
          sortable={false}
          render={(record) => <ProcessingStatusField status={record?.processing_status} />}
        /> */}
        <ControlAudio label="Player" />
        <LinkField source="url" label="Url" text="Ver" sortable={false} />
        <TextField source="type" label="Tipo" sortable={false} />
        <BooleanField source="active" label="Ativo" sortable={false} />
        <DateField source="expires_at" locales="pt-BR" label="Expira em" sortable={false} showTime />
        {/* <BooleanField source="is_expired" label="Expirado" sortable={false} /> */}
        <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} showTime />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default MediaList;
